import { render, staticRenderFns } from "./UserManagementPanel.vue?vue&type=template&id=ed4894dc&scoped=true"
import script from "./UserManagementPanel.vue?vue&type=script&lang=js"
export * from "./UserManagementPanel.vue?vue&type=script&lang=js"
import style0 from "./UserManagementPanel.vue?vue&type=style&index=0&id=ed4894dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4894dc",
  null
  
)

export default component.exports